import client from "@/api/openapi-ts";
import { defineStore, acceptHMRUpdate } from "pinia";

export const useTaskStore = defineStore("task", () => {
  return {
    async cancelTask(task_id: string) {
      const { error } = await client.GET("/api/v1/tasks/{task_id}/cancel", {
        params: { path: { task_id } },
      });
      if (error) throw error;
    },
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTaskStore, import.meta.hot));
}
